import React from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import { dialogSelector } from 'components/redux-dialog/selectors';
import { hideDialogAction } from 'components/redux-dialog/actions';
import { BlockUi } from 'components/block-ui';
import { close } from 'components/redux-dialog/fragments/close';
import { get } from 'lodash-es';

class Dialog extends React.Component {
  constructor(props) {
    super(props);
    close.register(this.closeDialog);
  }

  closeDialog = () => {
    document.body.style.overflowY = '';
    this.props.hideDialog();
    this.props.closeDialogCb && this.props.closeDialogCb();
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.dialog.show && this.props.dialog.show && this.props.onOpen) {
      this.props.onOpen();
    }

    if (prevProps.dialog.show && !this.props.dialog.show) {
      document.body.style.overflowY = '';
    }
  }

  componentWillUnmount() {
    document.body.style.overflowY = '';
  }

  render() {
    if (!this.props.dialog.show) {
      return null;
    }
    const dataE2e = get(this.props, 'data-e2e', 'dialog');

    document.body.style.overflowY = 'hidden';

    return (
      <BlockUi show={true}>
        <div
          data-e2e={dataE2e}
          className={`ct-dialog container ${this.props.className || ''}`}
          style={this.props.style}
        >
          {this.props.children}
        </div>
      </BlockUi>
    );
  }
}

const dispatchStateToProps = (dispatch, props) => ({
  hideDialog: () => dispatch(hideDialogAction(props.dialogName)),
});

const mapStateToProps = (state, props) => ({
  dialog: dialogSelector(state)(props.dialogName),
});

export const DialogDecorated = connect(mapStateToProps, dispatchStateToProps)(Dialog);

Dialog.propTypes = {
  dialogName: PropTypes.string,
  closeDialogCb: PropTypes.func,
  className: PropTypes.string,
  onOpen: PropTypes.func,
};
